/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phone_HelpInputs */



/**
* | output |
* | --- |
* | "A verified phone number allows you to receive SMS alerts" |
*
* @param {Phone_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_help = /** @type {((inputs?: Phone_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("A verified phone number allows you to receive SMS alerts")
	return /** @type {LocalizedString} */ ("Un numéro de téléphone vérifié permet de recevoir des alertes par SMS")
});